import React from 'react';
import { GridApi } from 'ag-grid-community';
import { AgGrid } from 'components/AgGrid';
import { getColumnDefs } from './CompareYearTable.helpers';
import { ICompareYearTableRow, ICurrencyFormat } from 'utils/types';

export const CompareYearTable = ({
  format,
  data,
}: {
  data: ICompareYearTableRow[];
  format?: ICurrencyFormat;
}) => {
  const [gridApi, setGridApi] = React.useState<GridApi>();
  const columnDefs = getColumnDefs(format);
  const defaultColDef = {
    suppressMenu: true,
    cellStyle: { padding: '0 11px' },
  };
  window.addEventListener('resize', () => {
    if (gridApi) {
      gridApi.sizeColumnsToFit();
    }
  });
  return (
    <div>
      <AgGrid
        className="ag-theme-balham compare-year-table"
        defaultColDef={defaultColDef}
        groupRemoveSingleChildren
        rowData={data}
        rowClass="compare-year-table--row"
        columnDefs={columnDefs}
        rowHeight={60}
        onGridReady={({ api }) => {
          setGridApi(api);
          api.sizeColumnsToFit();
        }}
        onGridSizeChanged={({ api }) => {
          api.sizeColumnsToFit();
        }}
        domLayout="autoHeight"
      />
    </div>
  );
};

export default CompareYearTable;
